import React from 'react'
import Section from '../Section'
import Footer from './Footer'
import HeroSection from './HeroSection'
import HowWeRollSection from './how-we-roll/HowWeRollSection'
import TheProblemSection from './TheProblemSection'
import TheSolutionSection from './TheSolutionSection'
import WhyNowSection from './WhyNowSection'

const Home = () => {
  return (
    <>
      <Section shouldCoverFullHeight={true}>
        <HeroSection />
      </Section>
      <Section shouldCoverFullHeight={true} isDark={true}>
        <TheProblemSection />
      </Section>
      <Section shouldCoverFullHeight={true}>
        <HowWeRollSection />
      </Section>
      <Section shouldCoverFullHeight={true} isDark={true}>
        <TheSolutionSection />
      </Section>
      <Section shouldCoverFullHeight={false}>
        <WhyNowSection />
      </Section>
      <Footer />
    </>
  )
}

export default Home
